import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { FaStar } from 'react-icons/fa';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { addReview } from '../../features/home/bookingSlice';
import { Booking, BookingTrip } from '../../types';

interface RatingModalProps {
    isOpen: boolean;
    onClose: () => void;
    type: "Place" | "Trip";
    bookingTrip?: BookingTrip| null;
    bookingPlace?: Booking| null;
}

const RatingModal = ({ isOpen, onClose, type, bookingTrip, bookingPlace }: RatingModalProps) => {
    const [rating, setRating] = useState(0);
    const [hovered, setHovered] = useState<number | null>(null);
    const [comment, setComment] = useState('');
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch<AppDispatch>()
    const handleSubmit = () => {
        if (rating === 0 || comment.trim() === '') return;
        let reviewData: any = {
            userId: type === "Place" ? bookingPlace?.userId : bookingTrip?.userId,
            type,
            rating,
            comment,
            ...(type === "Place"
                ? { placeId: bookingPlace?.place?.id }
                : { tripId: bookingTrip?.trip?.id })
        };

        dispatch(addReview(reviewData));
        // Reset
        setRating(0);
        setComment('');
        onClose();
    };

    return (
        <Dialog open={isOpen} onClose={onClose} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} className="relative z-50">
            <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
            <div className="fixed inset-0 flex items-center justify-center p-4">
                <DialogPanel className="w-full max-w-lg text-black bg-white rounded-xl p-6 shadow-xl">
                    <DialogTitle className="text-lg font-bold mb-4">{t('feedback')}</DialogTitle>
                    <div >
                        <label>{t("after-completing-feedback")}</label>
                        <textarea

                            className="w-full border focus:outline-none rounded-md p-2 mt-3 mb-6 text-sm"
                            rows={4}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                    </div>
                    <div>
                        <label>{t("stay-rating")}</label>
                        <div className="flex items-center gap-5 mt-3 mb-6">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <FaStar
                                    key={star}
                                    size={30}
                                    className={`cursor-pointer transition ${(hovered ?? rating) >= star ? 'text-secondry' : 'text-gray-300'}`}
                                    onClick={() => setRating(star)}
                                    onMouseEnter={() => setHovered(star)}
                                    onMouseLeave={() => setHovered(null)}
                                />
                            ))}
                        </div>
                    </div>

                    <button className="bg-primary hover:bg-[#005011]  w-full rounded-lg text-white py-2" onClick={handleSubmit}>
                        {t('submitRating')}
                    </button>
                </DialogPanel>
            </div>
        </Dialog>
    );
};

export default RatingModal;
